<div class="container-fluid p-6">
    <div class="row mb-4">
        <div class="col">
            <h6 class="mb-2">ENTWICKLUNG EINER HTML5 WEB KOMPONENTE</h6>
            <h2>SUPERMARQUEE - HTML5 WebComponent für Scroll Effekte</h2>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <p>
                SuperPlug.in ist eine Tocherfirma der aheadware GmbH. Sie entwickelt leistungsstarke Plugins und Softwarekomponenten für Webentwickler und Kreative.
            </p>
            <p>
                Das Flaggschiffprodukt, SuperMarquee, ist eine vielseitige und performante Lösung für Scrolltexte auf Webseiten, die mit allen gängigen Frontend-Frameworks kompatibel ist.
            </p>
        </div>
    </div>
    <div class="row" style="margin-top: 3rem">
        <!--
        <img src="/assets/images/references/ref-supermarquee.jpg" class="img-fluid" />
        -->
        <div class="ref-page-header-image"
             style="background-image: url(/assets/images/references/ref-supermarquee.jpg)"></div>
    </div>
    <div class="row" style="margin-top: 3rem">
        <div class="col-xl-4">
            <h2>TASK & CHALLENGE</h2>
        </div>
        <div class="col-xl-8">
            <p>
                Ziel des Projekts war die Entwicklung einer generischen HTML WebComponent, die eine Vielzahl von Inhalten wie Texte, Grafiken und Videos als scrollbares Element darstellt. Die Komponente sollte eine herausragende Performance bieten und ein flüssiges Nutzererlebnis gewährleisten – unabhängig von der Geräteklasse oder Bildschirmgröße.
            </p>
            <p>
                Eine besondere Herausforderung bestand darin, sicherzustellen, dass die WebComponent auf einer Vielzahl von Endgeräten, einschließlich leistungsschwächerer Systeme, zuverlässig und performant läuft. Zudem sollte sie universell einsetzbar sein.
            </p>
        </div>
    </div>
    <div class="row" style="margin-top: 6rem">
        <div class="col-xl-4">
            <h2>SOLUTION</h2>
        </div>
        <div class="col-xl-8">
            <p>
                Die entwickelte HTML WebComponent erfüllt alle Anforderungen und setzt neue Maßstäbe in Leistung und Flexibilität. Dank modernster Webtechnologien und optimierter Rendering-Methoden gewährleistet die Komponente eine herausragende Performance selbst bei großen Datenmengen und auf leistungsschwächeren Geräten.
            </p>
            <p>
                Die WebComponent ist vollständig generisch und plattformübergreifend einsetzbar. Sie unterstützt die Integration in gängige Frontend-Frameworks wie Angular, React, Vue.js und Svelte, was eine schnelle und unkomplizierte Einbindung in bestehende Webprojekte ermöglicht. Durch ihre modulare Architektur und intuitive Nutzung bietet sie Entwicklern maximale Flexibilität und gewährleistet zugleich ein optimales Nutzererlebnis. Damit stellt die Lösung eine zukunftssichere und hochperformante Komponente für vielfältige Anwendungsszenarien dar.
            </p>
            <div style="margin-top: 2rem">
                <h4>TECHNOLOGIEN</h4>
                <div class="tech-icons">
                    <img class="img-fluid"
                         src="/assets/images/techicons/white/JS@2x-1.png" />
                    <img class="img-fluid"
                         src="/assets/images/techicons/white/HTML5 CSS3@2x-1.png" />
                </div>
            </div>
        </div>
    </div>
</div>
